@if (isBrowser) {
    <div class="p-24">
        <div
            class="vehicle-cart"
            id="itt-sl-ucl"
            [attr.data-dealerId]="shopIdentifier()"
            [attr.data-series]="series()"
            [attr.data-model]="model()"
            data-currency="EUR"
            data-language="de"
        ></div>
    </div>
}
